import type { FC, ReactElement } from "react"
import type { ResponsiveContainerProps } from "recharts"
import { ResponsiveContainer } from "recharts"

type DataContainerProps = {
  children: ReactElement | ReactElement[]
}

const DataContainer: FC<DataContainerProps & ResponsiveContainerProps> = ({
  children,
  ...responsiveContainerProps
}) => (
  <ResponsiveContainer height={500} width="100%" {...responsiveContainerProps}>
    {children}
  </ResponsiveContainer>
)

export default DataContainer
